/* @ngInject */
function AttachmentItemController (
  $rootScope,
  $interval,
  $timeout,
  $translate,
  Utils,
  AssetPreviewService,
  MessageService,
  NewAssetService,
  TasksService
) {
  var supportedTypes = ['IMAGE', 'PDF', 'VIDEO', 'ILLUSTRATOR', 'PHOTOSHOP']
  var ctrl = this
  ctrl.form = {
    newName: '',
    bIsEditingName: false,
    bErrorOnInput: false,
    bLoading: false
  }
  ctrl.bPreview = false
  ctrl.fileWasAttached = false
  ctrl.removeBackground = false
  ctrl.thumbnailWatcher = null

  ctrl.$onInit = function () {
    ctrl.bIsUserOwner = $rootScope.oUser
      ? $rootScope.oUser.id === ctrl.attachment.createdBy ||
        $rootScope.oUser.id === ctrl.attachment.userId ||
        $rootScope.oUser.id === ctrl.attachment.ownerId
      : false
    ctrl.userCanCreatePosts = $rootScope.oUser ? $rootScope.oUser.canCreatePost : false

    if (ctrl.attachment?.files?.[0]) {
      const originalFile = ctrl.attachment.files[0]

      ctrl.attachment = {
        // keep compatibility with older data model
        ...originalFile,
        ...ctrl.attachment
      }
    }
    ctrl.hasThumbnail = supportedTypes.includes(ctrl.attachment.type)
    ctrl.bCanPreview = !ctrl.attachment.uploading

    if (!ctrl.attachment.src) {
      ctrl.attachment.src = {}
    }

    if (!ctrl.hasThumbnail) {
      ctrl.thumbnailSrc = '/assets/img/repository_asset_thumbs/file.png'
      ctrl.removeBackground = true
    } else {
      const setThumbUrl = () => {
        const url = NewAssetService.getAssetThumbnailUrl(ctrl.attachment.id, 'LOW', { includeDateAsQueryString: true })

        $timeout(() => {
          ctrl.attachment.src.thumbnail = url
          ctrl.thumbnailSrc = url
        })
      }
      const watcherHandler = () => {
        return NewAssetService.checkAssetHasThumb(ctrl.attachment.id, 'LOW').then(hasGeneratedThumb => {
          if (hasGeneratedThumb) {
            setThumbUrl()
            $interval.cancel(ctrl.thumbnailWatcher)
          }
        })
      }
      setThumbUrl()

      if (!ctrl.thumbnailWatcher) {
        ctrl.thumbnailWatcher = $interval(watcherHandler, 8000)
      }
    }

    $('.dropdown.options-item-button').dropdown({
      action: 'hide',
      on: 'hover',
      showOnFocus: false
    })
  }

  ctrl.$onDestroy = () => {
    if (ctrl.thumbnailWatcher) {
      $interval.cancel(ctrl.thumbnailWatcher)
    }
  }
  ctrl.$onChanges = ctrl.$onInit

  ctrl.downloadAttachment = function (event) {
    event.preventDefault()
    event.stopPropagation()

    if (ctrl.mActions && ctrl.mActions.download) {
      ctrl.mActions.download(ctrl.attachment, ctrl.formatFileName)
    }
  }

  ctrl.formatFileExtension = function (oAttachment) {
    var sExt = Utils.beautifyContentTypes(oAttachment.contentType).toUpperCase()
    if (sExt !== '') {
      return sExt
    } else if (typeof oAttachment.type !== 'undefined') {
      return oAttachment.type
    }
    return ''
  }

  ctrl.formatFileName = function (sName) {
    if (sName) {
      return sName
    } else {
      return $translate.instant('noTitle')
    }
  }

  ctrl.deleteAttachment = function (event) {
    event.preventDefault()
    event.stopPropagation()

    MessageService.warning({
      title: $translate.instant('warning'),
      text: $translate.instant('areYouSureDeleteAsset'),
      cancelButton: $translate.instant('no'),
      confirmButton: $translate.instant('yes'),
      closeOnConfirm: true,
      press: function () {
        ctrl.bDeleted = true
        if (ctrl.mActions && ctrl.mActions.delete) {
          ctrl.mActions.delete(ctrl.attachment.id)
        }
      }
    })
  }

  ctrl.handleEditAttachmentName = function () {
    if (ctrl.form.bErrorOnInput) {
      return
    }
    ctrl.attachment.name = ctrl.form.newName
    ctrl.form.bIsEditingName = false
    ctrl.mActions.update(ctrl.attachment.id, { name: ctrl.form.newName })
  }

  ctrl.seeAttachmentLogs = function (event) {
    event.preventDefault()
    event.stopPropagation()

    if (ctrl.mActions.seeAttachmentLogs) {
      ctrl.mActions.seeAttachmentLogs(ctrl.attachment.id)
    }
  }

  ctrl.preview = function () {
    if (ctrl.location) {
      return
    }

    if (ctrl.mActions.logPostView) {
      ctrl.mActions.logPostView(ctrl.attachment.id)
    }

    const asset = {
      ...ctrl.attachment,
      assetId: ctrl.attachment.id
    }

    AssetPreviewService.openAssetPreview({
      asset,
      location: 'briefing',
      getPreviewAssets
    })
  }

  ctrl.onThumbnailLoadError = function () {
    return ctrl.attachment.src.default
  }

  ctrl.updateAttachmentVisibility = function () {
    const newStatus = !ctrl.attachment.isPrivate
    TasksService.updateTaskAttachmentVisibility(ctrl.attachment.id, newStatus)
      .then(([response]) => {
        ctrl.attachment.isPrivate = response.isPrivate
      })
      .catch(MessageService.defaultErrorMessage)
  }

  function getPreviewAssets () {
    const count = ctrl.attachment.previewAssets.length
    const assets = ctrl.attachment.previewAssets.map(previewAsset => ({
      ...previewAsset,
      assetId: previewAsset.id
    }))

    return Promise.resolve({
      count,
      assets
    })
  }
}

export { AttachmentItemController }
